import api from './client.js'

export const tournamentsAPI = {
  getTournaments: (params) => api.get('/tournaments', { params }),
  getTournament: (tournamentId) => api.get(`/tournaments/${tournamentId}`),
  createTournament: (tournamentData) => api.post('/tournaments', tournamentData),
  updateTournament: (tournamentId, tournamentData) =>
    api.put(`/tournaments/${tournamentId}`, tournamentData),
  deleteTournament: (tournamentId) => api.delete(`/tournaments/${tournamentId}`),
  cancelTournament: (tournamentId) => api.patch(`/tournaments/${tournamentId}/cancel`),
  updateTournamentType: (tournamentId, payload) => api.patch(`/tournaments/${tournamentId}/type`, payload),
  joinTournament: (tournamentId, data) => api.post(`/tournaments/${tournamentId}/register`, data),
  registeredUsers: (tournamentId) => api.get(`/tournaments/${tournamentId}/registered-users`),
  leaveTournament: (tournamentId) => api.post(`/tournaments/${tournamentId}/leave`),
  startTournament: (tournamentId) => api.post(`/tournaments/${tournamentId}/start`),
  getMatch: (tournamentId, matchId) => api.get(`/tournaments/${tournamentId}/matches/${matchId}`),
  updateMatch: (tournamentId, matchId, matchData) =>
    api.patch(`/tournaments/${tournamentId}/matches/${matchId}`, matchData),
  removeParticipant: (tournamentId, participantId) =>
    api.delete(`/tournaments/${tournamentId}/participants/${participantId}`),
  markParticipantGivenUp: (tournamentId, participantId) =>
    api.patch(`/tournaments/${tournamentId}/participants/${participantId}/give-up`),
  updateDeathmatchScores: (tournamentId, matchId, scores) =>
    api.patch(`/tournaments/${tournamentId}/matches/${matchId}/deathmatch-scores`, { scores }),
  // Match ↔ game-server koppeling voor overlay-context (F1-overlay). null = ontkoppelen.
  setMatchServer: (tournamentId, matchId, gameServerId) =>
    api.patch(`/tournaments/${tournamentId}/matches/${matchId}/server`, { game_server_id: gameServerId }),
  updateParticipantSeeding: (tournamentId, seedingData) =>
    api.patch(`/tournaments/${tournamentId}/participants/seeding`, { seeding: seedingData }),
  updateFeatures: (tournamentId, features) =>
    api.patch(`/tournaments/${tournamentId}/features`, { features }),
  checkIn: (tournamentId) => api.post(`/tournaments/${tournamentId}/check-in`),
  markReady: (tournamentId) => api.post(`/tournaments/${tournamentId}/ready`),
  adminMarkNoShow: (tournamentId, participantId, no_show = true) =>
    api.patch(`/tournaments/${tournamentId}/participants/${participantId}/no-show`, { no_show }),
  getStageState:    (tournamentId) => api.get(`/tournaments/${tournamentId}/stage-state`),
  updateStageState: (tournamentId, patch) => api.patch(`/tournaments/${tournamentId}/stage-state`, patch),
  setPrize:    (tournamentId, prize_id) => api.patch(`/tournaments/${tournamentId}/prize`, { prize_id }),
  awardPrize:  (tournamentId) => api.post(`/tournaments/${tournamentId}/award-prize`),
  setPointsReward: (tournamentId, points_reward) => api.patch(`/tournaments/${tournamentId}/points-reward`, { points_reward }),
  awardPoints:     (tournamentId) => api.post(`/tournaments/${tournamentId}/award-points`),
  listPredictions: (tournamentId) => api.get(`/tournaments/${tournamentId}/predictions`),
  placePrediction: (tournamentId, matchId, pick_participant_id, points_wagered) =>
    api.post(`/tournaments/${tournamentId}/matches/${matchId}/predict`, { pick_participant_id, points_wagered }),
  setBadge:    (tournamentId, badge_type_id) => api.patch(`/tournaments/${tournamentId}/badge`, { badge_type_id }),
  awardBadge:  (tournamentId) => api.post(`/tournaments/${tournamentId}/award-badge`),
  awardAll:    (tournamentId) => api.post(`/tournaments/${tournamentId}/award-all`),
  callMatchPlayers: (tournamentId, matchId) =>
    api.post(`/tournaments/${tournamentId}/matches/${matchId}/call-players`),
  listTemplates:        () => api.get('/tournaments/templates'),
  createFromTemplate:   (templateId, overrides) => api.post(`/tournaments/from-template/${templateId}`, overrides),
  createTemplate:   (data) => api.post('/tournaments/templates', data),
  updateTemplate:   (id, data) => api.patch(`/tournaments/templates/${id}`, data),
  deleteTemplate:   (id) => api.delete(`/tournaments/templates/${id}`),
  markMatchReady:   (tournamentId, matchId) => api.post(`/tournaments/${tournamentId}/matches/${matchId}/ready`),
  resetMatchReady:  (tournamentId, matchId) => api.delete(`/tournaments/${tournamentId}/matches/${matchId}/ready`),
  getSwissStandings:    (tournamentId) => api.get(`/tournaments/${tournamentId}/swiss/standings`),
  generateNextSwissRound: (tournamentId) => api.post(`/tournaments/${tournamentId}/swiss/next-round`),
  ladderNextChallenger: (tournamentId) => api.post(`/tournaments/${tournamentId}/ladder/next-challenger`),
  startGroupKnockout:   (tournamentId) => api.post(`/tournaments/${tournamentId}/group-ko/start-knockout`),
}

export const statsAPI = {
  getPlayerStats: (userId) => api.get(`/stats/players/${userId}`),
  getMyStats: () => api.get('/stats/players'),
  getLeaderboard: (params) => api.get('/stats/leaderboard', { params }),
  getAchievements: () => api.get('/stats/achievements'),
  getMatchSchedule: (tournamentId) => api.get(`/stats/tournaments/${tournamentId}/schedule`),
  updateMatchSchedule: (tournamentId, matchId, scheduleData) =>
    api.patch(`/stats/tournaments/${tournamentId}/matches/${matchId}/schedule`, scheduleData),
}

export const teamImagesAPI = {
  uploadLogo: (participantId, formData) => api.post(`/team-images/participant/${participantId}/logo`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  uploadBanner: (participantId, formData) => api.post(`/team-images/participant/${participantId}/banner`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  deleteLogo: (participantId) => api.delete(`/team-images/participant/${participantId}/logo`),
  deleteBanner: (participantId) => api.delete(`/team-images/participant/${participantId}/banner`),
  adminRemoveLogo: (participantId) => api.delete(`/team-images/admin/participant/${participantId}/logo`),
  adminRemoveBanner: (participantId) => api.delete(`/team-images/admin/participant/${participantId}/banner`),
}
